import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import {
  ConfirmDialogModel,
  ConfirmDialogService,
  MsgBoxType,
  ToastService,
} from '@ui';
import { SharedActions } from '../state/shared/shared.actions';

export const showMessage$ = createEffect(
  (
    actions$ = inject(Actions),
    toastService = inject(ToastService),
  ) =>
    actions$.pipe(
      ofType(SharedActions.showMessage),
      tap(({ error, warning, success, info }) => {
        if (error) {
          toastService.showCustomAlert(error, MsgBoxType.ERROR);
        }
        if (warning) {
          toastService.showCustomAlert(warning, MsgBoxType.WARNING);
        }
        if (success) {
          toastService.showCustomAlert(success, MsgBoxType.SUCCESS);
        }
        if (info) {
          toastService.showCustomAlert(info, MsgBoxType.INFO);
        }
      }),
    ),
  { functional: true, dispatch: false },
);

export const confirmation$ = createEffect(
  (
    actions$ = inject(Actions),
    confirmDialogService = inject(ConfirmDialogService),
  ) =>
    actions$.pipe(
      ofType(SharedActions.showConfirmModal),
      switchMap(({ options }) =>
        confirmDialogService.open(options).pipe(
          map((result) => {
            const params = options.params ?? {};

            if (
              result?.selection === ConfirmDialogModel.ConfirmResult.OK &&
              result?.type === ConfirmDialogModel.ConfirmDialogType.CONFIRM
            ) {
              return SharedActions.showConfirmModalResultConfirm({ params });
            }

            return SharedActions.showConfirmModalResultCancel({ params });
          }),
          catchError(() =>
            of(
              SharedActions.showConfirmModalResultCancel({
                params: options.params ?? {},
              }),
            ),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const showConfirmNameModal$ = createEffect(
  (
    actions$ = inject(Actions),
    confirmDialogService = inject(ConfirmDialogService),
  ) =>
    actions$.pipe(
      ofType(SharedActions.showConfirmNameModal),
      switchMap(({ options }) =>
        confirmDialogService.openNameConfirm(options).pipe(
          map((result) => {
            const params = options.params ?? {};
            if (result === ConfirmDialogModel.ConfirmResult.OK) {
              return SharedActions.showConfirmNameModalResultConfirm({ params });
            }
            return SharedActions.showConfirmNameModalResultCancel({ params });
          }),
          catchError(() =>
            of(
              SharedActions.showConfirmNameModalResultCancel({
                params: options.params ?? {},
              }),
            ),
          ),
        ),
      ),
    ),
  { functional: true },
);
